import { number } from "zod";
import { ModuleType } from "../../queryKeyFactory";

export const listsKeyFactory = {
  configCategoryJson: (
    config,
    remoteUtilityId: string,
    configLevel: string,
    codeList?: any
  ): [ModuleType, "config-category-json", string, string, string, any?] => [
    "ux",
    "config-category-json",
    config,
    remoteUtilityId,
    configLevel,
    codeList,
  ],
  fetchConsumerData: (
  remoteUtilityId: string,
  currentPage,
  filterType: string,
  uniqueKey: string
): [ModuleType, "fetch-consumer-data", string, number, string, string] => [
  "ux",
  "fetch-consumer-data",
  remoteUtilityId,
  currentPage,
  filterType,
  uniqueKey,
],
recipientListDetail: (
  listId: string | number
): [ModuleType, "recipient-list-detail",  string | number] => [
  "ux",
  "recipient-list-detail",
  listId,
],
};
